/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    SPLIT_COMPANY_PROFILE_SOCIAL
 * Date:         2025-12-29
 * Modified By:  Cursor
 *
 * Description:
 * Extracted company social media section from CompanyProfileForm.tsx.
 *
 * Related Screens / Modules:
 * - client/src/components/setup/company-profile/components/SocialMedia.tsx
 */
import React from "react";
import { Form } from "react-bootstrap";

export const SocialMedia: React.FC<{ formik: any }> = ({ formik }) => {
  // [2026-02-06] Changed type="url" to type="text" to use Yup validation messages instead of browser default
  return (
    <div className="mt-3 social-links-group">
      <div className="social-link-row">
        <div className="social-link-icon"><img src="/assets/social.svg" alt="LinkedIn" width={40} height={40} /></div>
        <Form.Control className="field-input" type="text" {...formik.getFieldProps("companyLinkedIn")} isInvalid={!!(formik.touched.companyLinkedIn && formik.errors.companyLinkedIn)} placeholder="LinkedIn link" />
      </div>
      <div className="social-link-row">
        <div className="social-link-icon"><img src="/assets/social (1).svg" alt="Facebook" width={40} height={40} /></div>
        <Form.Control className="field-input" type="text" {...formik.getFieldProps("companyFacebook")} isInvalid={!!(formik.touched.companyFacebook && formik.errors.companyFacebook)} placeholder="Facebook link" />
      </div>
      <div className="social-link-row">
        <div className="social-link-icon"><img src="/assets/social (2).svg" alt="Instagram" width={40} height={40} /></div>
        <Form.Control className="field-input" type="text" {...formik.getFieldProps("companyInstagram")} isInvalid={!!(formik.touched.companyInstagram && formik.errors.companyInstagram)} placeholder="Instagram link" />
      </div>
      <div className="social-link-row">
        <div className="social-link-icon"><img src="/assets/social (3).svg" alt="X" width={40} height={40} /></div>
        <Form.Control className="field-input" type="text" {...formik.getFieldProps("companyX")} isInvalid={!!(formik.touched.companyX && formik.errors.companyX)} placeholder="X link" />
      </div>
    </div>
  );
};
